/**
 * SnapshotList - the database copies an environment holds.
 *
 * Its own file because both halves of the Entornos section show it: the
 * personal table expands into one, and each project card can open one. A second
 * copy is how "3 copias · 1.2 GB" in one place and "3 snapshots" in the other
 * start disagreeing about what the store contains.
 */
import type { AdminEnvironmentSnapshots } from "../../auth/EnvironmentsClient";
import { formatBytes } from "./EnvironmentsSection.logic";

export function SnapshotList(props: { snapshots: AdminEnvironmentSnapshots }) {
  const { snapshots, totalBytes, error } = props.snapshots;
  if (error !== null) {
    return <p className="text-xs text-amber-300">No se pudo leer el almacén de copias: {error}</p>;
  }
  if (snapshots.length === 0) {
    return <p className="text-xs text-muted-foreground">Este entorno no tiene copias todavía.</p>;
  }
  return (
    <div className="flex flex-col gap-2">
      <p className="text-xs text-muted-foreground">
        {snapshots.length} {snapshots.length === 1 ? "copia" : "copias"} · {formatBytes(totalBytes)}{" "}
        en disco
      </p>
      <ul className="flex flex-col gap-1">
        {snapshots.map((snapshot) => (
          <li
            key={snapshot.snapshotId}
            className="flex items-center justify-between gap-3 rounded border border-border/40 bg-card/30 px-3 py-1.5 text-xs"
          >
            <span className="min-w-0 truncate font-medium">{snapshot.label}</span>
            <span className="shrink-0 text-muted-foreground">
              {snapshot.engine} · {formatBytes(snapshot.sizeBytes)} ·{" "}
              {new Date(snapshot.createdAt).toLocaleString()}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
